import { Badge } from "@/components/ui/badge";
import type { ContestScreening } from "@/types/contest-submission";

const RESULT_CONFIG: Record<string, { label: string; className: string }> = {
  pending: {
    label: "검토중",
    className: "bg-gray-100 text-gray-700 border-gray-200",
  },
  pass: {
    label: "적격",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  fail: {
    label: "부적격",
    className: "bg-rose-100 text-rose-800 border-rose-200",
  },
};

const FALLBACK = {
  label: "알 수 없음",
  className: "bg-gray-100 text-gray-500 border-gray-200",
};

/**
 * 1차 심사 판정 뱃지. screening 부재(legacy doc)는 심사전으로 취급.
 * 서버 enum 은 대문자 — 렌더 경계에서만 toLowerCase 정규화 (handbook 패턴).
 */
export function ContestScreeningBadge({
  screening,
}: {
  screening: ContestScreening | null;
}) {
  const normalized = (screening?.result ?? "PENDING").toLowerCase();
  const config = RESULT_CONFIG[normalized] ?? FALLBACK;
  return (
    <Badge
      variant="outline"
      className={config.className}
      aria-label={`심사 결과: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
